module.exports = __webpack_public_path__ + "static/media/feel-invigorated.b8d75d12.jpg";